import React from "react";
import AppRoutes from "../AppRoutes";
import NavBar from "./Navigation/NavBar";
import Sidebar from "./Navigation/Sidebar";
import {SystemError} from "./Error/SystemError";
import useAppContext from "../util/AppContext";
import TokenExchange from "./Login2/TokenExchange";

export default function Layout() {
    // THE RAIL IS FOR SOMEBODY WHO IS IN. Signed out, the only thing on screen is the splash, and a
    // column of destinations nobody can reach is furniture.
    const signedIn = !!useAppContext()?.sessionContext?.valid?.();

    return (
        <div style={{display: "flex", flexDirection: "column", height: "100vh"}}>
            <TokenExchange />
            <NavBar />
            <div style={{display: "flex", flexDirection: "row", flex: 1, minHeight: 0}}>
                {signedIn && <Sidebar />}
                <div style={{flex: 1, overflow: "auto"}}>
                    <AppRoutes />
                </div>
            </div>
            <SystemError />
        </div>
    );
}
